import { Data } from "@react-google-maps/api";
import axios from "axios";
const api_base_url = process.env.REACT_APP_API_BASEURL;

export const getLeasedEquipment = async () => {
  const data = await axios.get(`${api_base_url}/LeasedEquipment`);
  return data;
};

export const getLeasedEquipmentCount = async () => {
  const data = await axios.get(`${api_base_url}/LeasedEquipment/GetCount`);
  return data;
};

//Add Leased Equipment
export const addLeasedEquipment = async (newLE) => {
  const formData = new FormData();
  newLE.recordNumber && formData.append("recordNumber", newLE.recordNumber);
  newLE.type && formData.append("type", newLE.type);
  newLE.make && formData.append("make", newLE.make);
  newLE.modelId && formData.append("modelId", newLE.modelId);
  newLE.serialNumber && formData.append("serialNumber", newLE.serialNumber);
  newLE.tagNumber && formData.append("tagNumber", newLE.tagNumber);
  newLE.ipaddress && formData.append("ipaddress", newLE.ipaddress);
  newLE.statusId && formData.append("statusId", newLE.statusId);
  newLE.status && formData.append("status", newLE.status);
  newLE.equipmentReturned !== null &&
    formData.append("equipmentReturned", newLE.equipmentReturned);
  newLE.previousLocation &&
    formData.append("previousLocation", newLE.previousLocation);
  newLE.leaseNumber && formData.append("leaseNumber", newLE.leaseNumber);
  newLE.leaseStartDate &&
    formData.append("leaseStartDate", newLE.leaseStartDate);
  newLE.leaseEndDate && formData.append("leaseEndDate", newLE.leaseEndDate);
  newLE.description && formData.append("description", newLE.description);
  newLE.createdBy && formData.append("createdBy", newLE.createdBy);
  newLE.createdDate && formData.append("createdDate", newLE.createdDate);
  newLE.lastModifiedBy &&
    formData.append("lastModifiedBy", newLE.lastModifiedBy);
  newLE.lastModifiedDate &&
    formData.append("lastModifiedDate", newLE.lastModifiedDate);
  newLE.isActive && formData.append("isActive", newLE.isActive);
  newLE.officeId && formData.append("officeId", newLE.officeId);
  newLE.officeName && formData.append("officeName", newLE.officeName);
  newLE.name && formData.append("name", newLE.name);
  newLE.vendorId && formData.append("vendorId", newLE.vendorId);
  newLE.email && formData.append("email", newLE.email);
  newLE.tonerRequestEmail &&
    formData.append("tonerRequestEmail", newLE.tonerRequestEmail);
  newLE.tonerRequestPhone &&
    formData.append("tonerRequestPhone", newLE.tonerRequestPhone);
  newLE.contact && formData.append("contact", newLE.contact);
  newLE.attachments &&
    newLE.attachments.map((x) => formData.append("attachments", x));

  newLE.fileName && formData.append("fileName", newLE.fileName);
  newLE.vendorStorageId &&
    formData.append("vendorStorageId", newLE.vendorStorageId);

  //newly added fields

  newLE.customerNumber &&
    formData.append("customerNumber", newLE.customerNumber);
  newLE.vendorLocationNumber &&
    formData.append("vendorLocationNumber", newLE.vendorLocationNumber);
  newLE.purchasingVendorNumber &&
    formData.append("purchasingVendorNumber", newLE.purchasingVendorNumber);
  newLE.leaseAmount && formData.append("leaseAmount", newLE.leaseAmount);
  newLE.returnedEquipmentRm &&
    formData.append("returnedEquipmentRm", newLE.returnedEquipmentRm);
  newLE.returnedEquipmentDate &&
    formData.append("returnedEquipmentDate", newLE.returnedEquipmentDate);
  newLE.cancellationDate &&
    formData.append("cancellationDate", newLE.cancellationDate);
  //newly added fields
  newLE.makeId && formData.append("makeId", newLE.makeId);
  newLE.typeId && formData.append("typeId", newLE.typeId);
  newLE.supplyAlertProfileId &&
    formData.append("supplyAlertProfileId", newLE.supplyAlertProfileId);

  return await axios.post(`${api_base_url}/LeasedEquipment`, formData);
};

//Edit Leased Equipment
export const editLeasedEquipment = async (editLE) => {
  const formData = new FormData();
  editLE.recordNumber && formData.append("recordNumber", editLE.recordNumber);
  editLE.type && formData.append("type", editLE.type);
  editLE.make && formData.append("make", editLE.make);
  editLE.modelId && formData.append("modelId", editLE.modelId);
  editLE.serialNumber && formData.append("serialNumber", editLE.serialNumber);
  editLE.tagNumber && formData.append("tagNumber", editLE.tagNumber);
  editLE.ipaddress && formData.append("ipaddress", editLE.ipaddress);
  editLE.statusId && formData.append("statusId", editLE.statusId);

  editLE.status && formData.append("status", editLE.status);
  editLE.equipmentReturned !== null &&
    formData.append("equipmentReturned", editLE.equipmentReturned);

  editLE.previousLocation &&
    formData.append("previousLocation", editLE.previousLocation);
  editLE.leaseNumber && formData.append("leaseNumber", editLE.leaseNumber);
  editLE.leaseStartDate &&
    formData.append("leaseStartDate", editLE.leaseStartDate);
  editLE.leaseEndDate && formData.append("leaseEndDate", editLE.leaseEndDate);
  editLE.description && formData.append("description", editLE.description);
  editLE.createdBy && formData.append("createdBy", editLE.createdBy);
  editLE.createdDate && formData.append("createdDate", editLE.createdDate);
  editLE.lastModifiedBy &&
    formData.append("lastModifiedBy", editLE.lastModifiedBy);
  editLE.lastModifiedDate &&
    formData.append("lastModifiedDate", editLE.lastModifiedDate);
  editLE.isActive !== null && formData.append("isActive", editLE.isActive);
  editLE.officeId && formData.append("officeId", editLE.officeId);
  editLE.officeName && formData.append("officeName", editLE.officeName);
  editLE.name && formData.append("name", editLE.name);
  editLE.vendorId && formData.append("vendorId", editLE.vendorId);
  editLE.email && formData.append("email", editLE.email);
  editLE.tonerRequestEmail &&
    formData.append("tonerRequestEmail", editLE.tonerRequestEmail);
  editLE.tonerRequestPhone &&
    formData.append("tonerRequestPhone", editLE.tonerRequestPhone);
  editLE.contact && formData.append("contact", editLE.contact);
  editLE.attachments &&
    editLE.attachments.map((x) => formData.append("attachments", x));
  editLE.attachmentsForDelete &&
    editLE.attachmentsForDelete.forEach((obj, i) =>
      Object.entries(obj).forEach(([key, value]) => {
        formData.append(`attachmentsForDelete[${i}].${key}`, value);
        formData.append(
          `attachmentsForDelete[${i}].modifiedDate`,
          "2023-9-20T14:48:00"
        );
      })
    );
  editLE.customerNumber &&
    formData.append("customerNumber", editLE.customerNumber);
  editLE.vendorLocationNumber &&
    formData.append("vendorLocationNumber", editLE.vendorLocationNumber);
  editLE.purchasingVendorNumber &&
    formData.append("purchasingVendorNumber", editLE.purchasingVendorNumber);
  editLE.leaseAmount && formData.append("leaseAmount", editLE.leaseAmount);
  editLE.returnedEquipmentRm &&
    formData.append("returnedEquipmentRm", editLE.returnedEquipmentRm);
  editLE.returnedEquipmentDate &&
    formData.append("returnedEquipmentDate", editLE.returnedEquipmentDate);
  editLE.cancellationDate &&
    formData.append("cancellationDate", editLE.cancellationDate);

  editLE.fileName && formData.append("fileName", editLE.fileName);
  editLE.makeId && formData.append("makeId", editLE.makeId);
  editLE.typeId && formData.append("typeId", editLE.typeId);
  editLE.vendorStorageId &&
    formData.append("vendorStorageId", editLE.vendorStorageId);
  editLE.supplyAlertProfileId &&
    formData.append("supplyAlertProfileId", editLE.supplyAlertProfileId);
  return await axios.put(
    `${api_base_url}/LeasedEquipment/${editLE.recordNumber}`,
    formData
  );
};

export const getLeasedEquipmentByRecordNumber = async (recordNumber) => {
  let recordNumbers = recordNumber ?? 0;
  return await axios
    .get(`${api_base_url}/LeasedEquipment/${recordNumbers}`)
    .then((res) => {
      return res.data;
    });
};

export const getLeasedEquipmentByRecordNumbers = async (leIds) => {
  return await axios
    .post(
      `${api_base_url}/LeasedEquipment/GetLeasedEquipmentByRecordNumber`,
      leIds
    )
    .then((res) => {
      if (res) {
        return res.data;
      }
    });
};

export const getVendors = async () => {
  const data = await axios.get(`${api_base_url}/Common/Vendors`);
  return data;
};

export const getLeasedEquipmentMake = async () => {
  const data = await axios.get(
    `${api_base_url}/LeasedEquipment/ActiveLeasedEquipmentMake`
  );
  return data;
};

export const deleteLE = async (ids) => {
  return await axios.delete(`${api_base_url}/LeasedEquipment/DeactivatedLE`, {
    data: ids,
  });
};

export const getLeasedEquipmentByOfficeId = async (officeId) => {
  return await axios
    .get(`${api_base_url}/LeasedEquipment/ByOfficeId/${officeId}`)
    .then((res) => {
      return res.data;
    });
};

export const getLeasedEquipmentType = async () => {
  const data = await axios.get(
    `${api_base_url}/LeasedEquipment/ActiveLeasedEquipmentType`
  );
  return data;
};

export const getLeasedEquipmentSupplyAlertProfile = async () => {
  const data = await axios.get(
    `${api_base_url}/LeasedEquipment/ActiveLeasedEquipmentSupplyAlertProfile`
  );
  return data;
};

export const getLeasedEquipmentModel = async () => {
  const data = await axios.get(
    `${api_base_url}/LeasedEquipment/ActiveLeasedEquipmentModel`
  );
  return data;
};

export const getLeasedEquipmentStatus = async () => {
  const data = await axios.get(
    `${api_base_url}/LeasedEquipment/LeasedEquipmentStatus`
  );
  return data;
};

export const getLEForDownload = async (leIds) => {
  return await axios
    .post(`${api_base_url}/LeasedEquipment/GetLEForDownload`, leIds)
    .then((res) => {
      if (res) {
        return res.data;
      }
    });
};

export const downloadLeasedEquipmentTemplate = async (isOffice) => {
  var response = await axios.get(
    `${api_base_url}/LeasedEquipment/download/template/`,
    {
      params: { isOffice: isOffice },
      headers: { "Content-Type": "application/json" },
      responseType: "blob",
    }
  );
  return response;
};

export const uploadLeasedEquipment = async ({ file, isOffice }) => {
  var data = await axios.post(`${api_base_url}/LeasedEquipment/upload`, file, {
    params: { isOffice: isOffice },
    headers: { "Content-Type": "multipart/form-data" },
  });

  return data;
};

export const uploadValidMassLEData = async (validData) => {
  return await axios.post(
    `${api_base_url}/LeasedEquipment/massupload`,
    validData
  );
};

export const validateMassLEData = async ({ updatedLe, isOffice }) => {
  return await axios.post(
    `${api_base_url}/LeasedEquipment/validate`,
    updatedLe,
    {
      params: { isOffice: isOffice },
    }
  );
};
